var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4645_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 20.386C15.4769 23.1903 12.5357 25.125 9.12527 25.125C4.36152 25.125 0.5 21.3267 0.5 16.6409C0.5 12.9846 2.84579 9.86076 6.14793 8.67157L6.63513 11.3694C4.61415 12.2924 3.20668 14.3158 3.20668 16.6409C3.20668 19.8535 5.87726 22.4626 9.12527 22.4626C12.0665 22.4626 14.5206 20.3505 14.9717 17.5994H15.6935L16.8844 20.386Z",
    fill: "#FEF8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4374 19.96L20.0602 22.4981L16.8663 15.3097H9.26958L7.89819 7.25165C8.16886 7.30489 8.43953 7.34039 8.7102 7.34039C9.37784 7.34039 10.0094 7.18065 10.5688 6.89666L10.8214 8.42309H16.5415V11.0855H11.2725L11.5432 12.6474H18.6527L21.4316 18.8951L24.2646 17.5639L25.4374 19.96Z",
    fill: "#FEF8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71015 6.61268C10.5139 6.61268 11.9762 5.17435 11.9762 3.40009C11.9762 1.62582 10.5139 0.1875 8.71015 0.1875C6.90635 0.1875 5.44409 1.62582 5.44409 3.40009C5.44409 5.17435 6.90635 6.61268 8.71015 6.61268Z",
    fill: "#FEF8EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4645_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9375,
    height: 24.9375,
    fill: "white",
    transform: "translate(0.5 0.1875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBorder);
export default __webpack_public_path__ + "static/media/no-border.9169ab5d783b35d692442179ed071b23.svg";
export { ForwardRef as ReactComponent };